import { render } from "./LeadTeams.vue?vue&type=template&id=0d81eac0&scoped=true"
import script from "./LeadTeams.vue?vue&type=script&lang=js"
export * from "./LeadTeams.vue?vue&type=script&lang=js"

import "./LeadTeams.vue?vue&type=style&index=0&id=0d81eac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d81eac0"]])

export default __exports__